@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.filter-bar-wrapper {
  width: 100%;
}

.filter-bar-actions-wrapper {
  display: flex;
  width: 100%;
  justify-content: flex-end;

  .alert-danger {
    padding: 5px;
    background-color: @product-page--filter-bar--error--background-color;
    border: 1px solid @product-page--filter-bar--error--border-color;
    color: @product-page--filter-bar--error--text-color;
    border-radius: 5px;
    font-size: 12px;
    display: flex;
    align-items: center;

    .icon {
      fill: @product-page--filter-bar--error--text-color;
      width: 15px;
      height: 16px;
      min-width: 15px;
      min-height: 16px;
      margin-right: 5px;
    }
  }
  .sidebar-toggle {
    padding: 10px;
  }
}
